import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "modalBackgroundBlocker" };
const _hoisted_2 = { class: "opModal inputModal" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "header" }, " Login ", -1);
const _hoisted_4 = { class: "body" };
const _hoisted_5 = { class: "form-group mt-2" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", null, "Username", -1);
const _hoisted_7 = { class: "form-group mt-2" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", null, "Password", -1);
const _hoisted_9 = {
    key: 0,
    class: "mt-2 text-danger"
};
const _hoisted_10 = { class: "mt-4 mw-700" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
                _createTextVNode(" Inserisci username e password per continuare "),
                _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        placeholder: "Username",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.username) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.username]
                    ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        placeholder: "Password",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.password) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.password]
                    ])
                ]),
                (_ctx.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Errore in fase di login, assicurati che i dati siano corretti "))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-block btn-primary",
                        onClick: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_ctx.login && _ctx.login(...args)))
                    }, " Login ")
                ])
            ])
        ])
    ]));
}
